import React, { useEffect, useMemo, useState } from "react";
import { getMedicamentos } from "../../services/api";
import MedicamentoCard from "../components/medicamentoCard";
import FiltersPanel from "../components/filtersPanel";
import "./search.css";

export default function Search() {
  const [q, setQ] = useState("");

  const [filters, setFilters] = useState({
    farmacia: "",
    sort: "precioActual",
    order: "asc",
    minPrecio: undefined,
    maxPrecio: undefined,
    page: 1,
    limit: 24,
    q: undefined,
  });

  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("idle");
  const [pharmacies, setPharmacies] = useState([]);

  const headerText = useMemo(
    () => (filters.q ? `Resultados para “${filters.q}”` : "Explora medicamentos"),
    [filters.q]
  );

  async function fetchData(params) {
    setStatus("loading");
    try {
      const clean = cleanParams(params);
      const data = await getMedicamentos(clean);
      const arr = Array.isArray(data?.data) ? data.data : data;
      setItems(Array.isArray(arr) ? arr : []);

      const setF = new Set();
      (Array.isArray(arr) ? arr : []).forEach((m) => m?.farmacia && setF.add(m.farmacia));
      setPharmacies(Array.from(setF).sort());

      setStatus("ok");
    } catch (e) {
      console.error(e);
      setStatus("error");
    }
  }

  useEffect(() => {
    fetchData(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onClickBuscar() {
    const next = { ...filters, q: q || undefined,page: 1 };
    setFilters(next);
    fetchData(next);
  }

  function handleSubmit(e) {
    e.preventDefault();
    onClickBuscar();
  }

  function cleanParams(params) {
  const out = {};
  for (const [k, v] of Object.entries(params || {})) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = v;
  }
  return out;
  }

  function onApplyFilters(f) {
    const next = { ...filters, ...f, page: 1 };
    setFilters(next);
    fetchData(next);
  }

  function onClearFilters() {
    const next = {
      q: q || undefined,
      farmacia: "",
      sort: "precioActual",
      order: "asc",
      minPrecio: undefined,
      maxPrecio: undefined,
      page: 1,
      limit: 24,
    };
    setFilters(next);
    fetchData(next);
  }

  return (
    <div className="search-page container">
      <div className="search-layout">
        <FiltersPanel
          pharmacies={pharmacies}
          initial={filters}
          onApply={onApplyFilters}
          onClear={onClearFilters}
        />

        <section className="search-content">
          <form className="search-bar" onSubmit={handleSubmit}>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Buscar por nombre o sustancia activa…"
              aria-label="Buscar medicamento"
            />

            <button type="submit" className="btn-primary">
              Buscar
            </button>

            <button type="button" className="btn-ghost" onClick={() => setQ("")} aria-label="Limpiar término de búsqueda">
              Limpiar
            </button>
          </form>

          <h2 className="search-title">{headerText}</h2>

          {status === "loading" && <div className="loading">Cargando…</div>}
          {status === "error" && (
            <div className="error">Hubo un error cargando los medicamentos.</div>
          )}

          {status === "ok" && items.length === 0 && (
            <div className="empty">
              No se encontraron resultados. Prueba con “metformina”, “glimepirida”…
            </div>
          )}

          {status === "ok" && items.length > 0 && (
            <div className="grid-cards">
              {items.map((m) => (
                <MedicamentoCard
                  key={m._id || m.enlace || m.nombre}
                  medicamento={m}      
                  favoritoId={m._id}
                />
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
